import React from 'react';
import ReactDOM from 'react-dom';
import Dialog from '../Dialog';
import { i18n } from '../../language';

const UserLeaveConfirmation = (message, callback, confirmOpen, setConfirmOpen, setUnEdit) => {
  const container = document.createElement('div');
  const { header, content } = JSON.parse(message);

  container.setAttribute('custom-confirm-view', '');

  const handleConfirm = (callbackState) => {
    ReactDOM.unmountComponentAtNode(container);
    setUnEdit();
    callback(callbackState);
    setConfirmOpen(false);
  };

  const handleCancel = (callbackState) => {
    ReactDOM.unmountComponentAtNode(container);
    callback();
    setConfirmOpen(false);
  };

  document.body.appendChild(container);

  ReactDOM.render(
    <Dialog
      open={confirmOpen}
      handleClose={handleCancel}
      handleCancel={handleCancel}
      title={header}
      cancel={i18n.t('DUTYASSIGN_CANCEL')}
      confirm={i18n.t('DUTYASSIGN_CONFIRM')}
      handleConfirm={handleConfirm}
    >
      <div
        style={{
          color: '#2e4469',
          fontSize: '1.25rem',
          fontFamily: 'NotoSans-Medium',
          fontWeight: 500,
          lineHeight: '1.875rem',
        }}
      >
        {content}
      </div>
    </Dialog>,
    container
  );
};

export default UserLeaveConfirmation;
